import * as ActionTypes from '../constants/actiontypes/auth';
import  *  as axios from 'axios';
import * as urls from '../constants/webapi/auth';

export function authenticateUser(credentials){
    return (dispatch) => {
		dispatch({ type: ActionTypes.AUTH_USER_REQUEST, credentials: credentials.userName });
		return axios.post(urls.authenticationUrl(), credentials)
		.then((response) => {
			dispatch({
				type: ActionTypes.AUTH_USER_SUCCESS,
				data: response.data
			});
		})
		.catch((error) => {
			if(error.response !== undefined && error.response.status === 423){
				return "Locked";
			}
			dispatch({
				type: ActionTypes.AUTH_USER_FAILURE,
				response: error.response
			});
			throw error.statusText;
		});
	};
}

export function sendMfaCode(token){
    return (dispatch) => {
		dispatch({ type: ActionTypes.SEND_MFA_CODE_REQUEST, token: token });
		return axios.post(urls.authenticationTwoFactorUrl(), {twoFactorAuthenticationToken: token})
		.then((response) => {
			dispatch({
				type: ActionTypes.SEND_MFA_CODE_SUCCESS,
				data: response.data
			});
		})
		.catch((error) => {
			dispatch({
				type: ActionTypes.SEND_MFA_CODE_FAILURE,
				response: error.response
			});
		});
	};
}

export function sendOTPCode(phoneNumber){
    return (dispatch) => {
		dispatch({ type: ActionTypes.SEND_OTP_CODE_REQUEST, phoneNumber: phoneNumber });
		return axios.post(urls.sendOTPUrl(), {phoneNumber: phoneNumber})
		.then((response) => {
			dispatch({
				type: ActionTypes.SEND_OTP_CODE_SUCCESS,
				data: response.data
			});
		})
		.catch((error) => {
			dispatch({
				type: ActionTypes.SEND_OTP_CODE_FAILURE,
				reason: error.response.status
			});
		});
	};
}

export function verifyOTPCode(phoneNumber, otpCode){
    return (dispatch) => {
		dispatch({ type: ActionTypes.VERIFY_OTP_REQUEST, phoneNumber: phoneNumber, otpCode:otpCode });
		return axios.post(urls.verifyOTPUrl(), {phoneNumber: phoneNumber, otpCode: otpCode})
		.then((response) => {
			dispatch({
				type: ActionTypes.VERIFY_OTP_SUCCESS,
				data: response.data
			});
		})
		.catch((error) => {
			dispatch({
				type: ActionTypes.VERIFY_OTP_FAILURE,
				response: error.response
			});
			throw error.statusText;
		});
	};
}

export function registerUser(credentials){
    return (dispatch) => {
		dispatch({ type: ActionTypes.REGISTER_USER_REQUEST, credentials: credentials.phoneNumber });
		return axios.post(urls.registerUserUrl(), credentials)
		.then((response) => {
			dispatch({
				type: ActionTypes.REGISTER_USER_SUCCESS,
				data: response.data
			});
		})
		.catch((error) => {
			dispatch({
				type: ActionTypes.REGISTER_USER_FAILURE,
				response: error.response
			});
			throw error.statusText;
		});
	};
}

export function resetAuth() { return (dispatch) => { dispatch({ type: ActionTypes.RESET_AUTH_STATE }); }; };

//#region ResetPassword
export function resetPassword(email, phoneNumber) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.RESET_PASSWORD_REQUEST});
		return axios.post(urls.resetPasswordEmail(), {email, phoneNumber})
			.then(() => {
				dispatch({
					type: ActionTypes.RESET_PASSWORD_SUCCESS
				});
			})
			.catch((error) => {
				dispatch({
					type: ActionTypes.RESET_PASSWORD_FAILURE,
					error: error.response
				});
				throw error;
			})
	};
}

export function setNewPasswordFromReset(userId, token, password){
	return (dispatch) => {
		dispatch({ type: ActionTypes.SET_NEWPASSWORD_REQUEST});
		return axios.post(urls.setNewPassword(userId), {ResetPasswordToken: decodeURIComponent(token), NewPassword: password})
			.then(() => {
				dispatch({
					type: ActionTypes.SET_NEWPASSWORD_SUCCESS
				});
			})
			.catch((error) => {
				dispatch({
					type: ActionTypes.SET_NEWPASSWORD_FAILURE,
					error: error.response
				});
				throw error;
			})
	};
}
//#endregion
